var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2000 900",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-5 {\n        fill: #f8a13b;\n      }\n\n      .cls-6 {\n        fill: #f8a442;\n      }\n\n      .cls-7 {\n        fill: #f8a039;\n      }\n\n      .cls-8 {\n        fill: #fab96d;\n      }\n\n      .cls-9 {\n        fill: #f9af59;\n      }\n\n      .cls-10 {\n        fill: #f9ae56;\n      }\n\n      .cls-11 {\n        fill: #f9aa4d;\n      }\n\n      .cls-12 {\n        fill: #f4f4f6;\n      }\n\n      .cls-13 {\n        fill: #f79829;\n      }\n\n      .cls-14 {\n        fill: #f5f5f7;\n      }\n\n      .cls-15 {\n        fill: #fcd4a5;\n      }\n\n      .cls-16 {\n        fill: #fcd5a7;\n      }\n\n      .cls-17 {\n        fill: #feeedb;\n      }\n\n      .cls-18 {\n        fill: red;\n      }\n\n      .cls-19 {\n        fill: #fbc483;\n      }\n\n      .cls-20 {\n        fill: #fbc586;\n      }\n\n      .cls-21 {\n        fill: #ff1c1c;\n      }\n\n      .cls-22 {\n        fill: #ff2e2e;\n      }\n\n      .cls-23 {\n        fill: #fde7ce;\n      }\n\n      .cls-24 {\n        fill: #fbcb93;\n      }\n\n      .cls-25 {\n        fill: #fde1c0;\n      }\n\n      .cls-26 {\n        fill: #999;\n      }\n\n      .cls-27 {\n        fill: #666;\n      }\n\n      .cls-28 {\n        fill: #333;\n      }\n\n      .cls-29 {\n        fill: #1f2b31;\n      }\n\n      .cls-30 {\n        fill: #2a363b;\n      }\n\n      .cls-31 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3.75px;\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-2);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m318.71,505.43h20.01v61.47c0,6.9-1.64,12.94-4.92,18.12-3.28,5.18-7.87,9.21-13.75,12.09-5.88,2.88-12.74,4.32-20.57,4.32s-14.73-1.44-20.61-4.32c-5.88-2.88-10.46-6.91-13.73-12.09-3.27-5.18-4.9-11.21-4.9-18.12v-61.47h20.01v59.76c0,3.6.79,6.81,2.38,9.61,1.59,2.8,3.83,5.01,6.72,6.61,2.9,1.6,6.27,2.4,10.12,2.4s7.26-.8,10.14-2.4c2.88-1.6,5.11-3.81,6.7-6.61,1.59-2.8,2.38-6.01,2.38-9.61v-59.76Zm56.48,0v94.66h-20.01v-94.66h20.01Zm75.34,96.04c-6.53,0-12.17-1.17-16.92-3.51-4.75-2.34-8.39-5.52-10.93-9.54-2.54-4.02-3.81-8.51-3.81-13.47,0-3.7.74-6.98,2.22-9.84,1.48-2.87,3.54-5.51,6.19-7.93,2.65-2.42,5.73-4.83,9.24-7.23l18.35-12.06c2.37-1.51,4.11-3.1,5.22-4.78,1.11-1.68,1.66-3.5,1.66-5.48s-.75-3.62-2.26-5.22c-1.51-1.6-3.65-2.39-6.42-2.36-1.85,0-3.45.41-4.81,1.22-1.36.82-2.41,1.88-3.17,3.19-.76,1.31-1.13,2.77-1.13,4.37,0,1.97.55,3.97,1.66,6.01,1.11,2.03,2.59,4.18,4.44,6.45s3.87,4.71,6.05,7.33l44.88,51.49h-20.52l-37.44-41.69c-2.46-2.8-4.92-5.74-7.37-8.8-2.45-3.07-4.49-6.33-6.12-9.8-1.63-3.47-2.45-7.23-2.45-11.3,0-4.59,1.07-8.72,3.21-12.39,2.14-3.67,5.15-6.57,9.04-8.71,3.88-2.14,8.41-3.21,13.59-3.21s9.42,1.02,13.1,3.07c3.68,2.05,6.52,4.76,8.5,8.13s2.98,7.08,2.98,11.12c0,4.47-1.1,8.51-3.3,12.13-2.2,3.62-5.29,6.86-9.27,9.73l-19.32,13.91c-2.62,1.91-4.55,3.86-5.8,5.85s-1.87,3.89-1.87,5.71c0,2.25.55,4.27,1.66,6.05s2.68,3.2,4.71,4.23c2.03,1.03,4.42,1.55,7.16,1.55,3.33,0,6.62-.76,9.87-2.29,3.25-1.53,6.21-3.7,8.87-6.52,2.67-2.82,4.8-6.17,6.4-10.05,1.6-3.88,2.4-8.18,2.4-12.89h16.32c0,5.79-.63,11.01-1.9,15.64-1.26,4.64-3.02,8.67-5.27,12.11-2.25,3.44-4.82,6.25-7.72,8.43-.92.59-1.82,1.14-2.68,1.66-.86.52-1.76,1.08-2.68,1.66-3.51,2.83-7.43,4.88-11.76,6.15-4.33,1.26-8.6,1.9-12.83,1.9Zm147.71-96.04h20.01v61.47c0,6.9-1.64,12.94-4.92,18.12-3.28,5.18-7.87,9.21-13.75,12.09-5.88,2.88-12.74,4.32-20.57,4.32s-14.73-1.44-20.61-4.32c-5.88-2.88-10.46-6.91-13.73-12.09-3.27-5.18-4.9-11.21-4.9-18.12v-61.47h20.01v59.76c0,3.6.79,6.81,2.38,9.61,1.59,2.8,3.83,5.01,6.72,6.61,2.9,1.6,6.27,2.4,10.12,2.4s7.26-.8,10.14-2.4c2.88-1.6,5.11-3.81,6.7-6.61,1.59-2.8,2.38-6.01,2.38-9.61v-59.76Zm55.23,0l19.09,32.26h.74l19.18-32.26h22.6l-28.89,47.33,29.53,47.33h-23.02l-19.41-32.31h-.74l-19.41,32.31h-22.92l29.63-47.33-29.07-47.33h22.69Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 203.77,
    y1: 637.38,
    x2: 844.52,
    y2: 465.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#232323"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 2000,
    height: 900
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1589.5,
    y1: 313.37,
    x2: 1634.5,
    y2: 313.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff1c1c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1589.5,
    y1: 322.75,
    x2: 1634.5,
    y2: 322.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbcd98"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1589.5,
    y1: 332.12,
    x2: 1634.5,
    y2: 332.12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7931e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    width: 2000,
    height: 900
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 216.28,
    y: 419,
    width: 615.74,
    height: 265.06
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m308.21,448.32c-.14-1.21-.7-2.15-1.69-2.82s-2.23-1-3.73-1c-1.07,0-2,.17-2.79.5-.78.34-1.39.8-1.82,1.38-.43.58-.65,1.25-.65,1.99,0,.62.15,1.16.44,1.61.29.45.68.83,1.16,1.13s1,.55,1.55.75c.55.2,1.09.37,1.6.49l2.56.67c.84.21,1.69.48,2.57.83.88.35,1.69.81,2.44,1.38s1.36,1.28,1.82,2.12c.46.84.7,1.85.7,3.03,0,1.48-.38,2.8-1.14,3.95-.76,1.15-1.87,2.06-3.31,2.72-1.44.67-3.19,1-5.23,1s-3.66-.31-5.09-.93-2.55-1.51-3.36-2.65c-.81-1.15-1.26-2.51-1.34-4.08h3.96c.08.95.39,1.73.93,2.36.54.63,1.23,1.09,2.08,1.39s1.78.45,2.79.45c1.12,0,2.11-.18,2.98-.53.87-.35,1.56-.85,2.06-1.48.5-.63.75-1.38.75-2.23,0-.78-.22-1.41-.66-1.9-.44-.49-1.03-.9-1.78-1.23-.75-.32-1.59-.61-2.52-.86l-3.09-.84c-2.1-.57-3.76-1.41-4.98-2.52-1.22-1.11-1.83-2.57-1.83-4.4,0-1.51.41-2.83,1.23-3.95.82-1.12,1.93-2,3.32-2.63,1.4-.63,2.97-.94,4.73-.94s3.34.31,4.7.93,2.43,1.48,3.22,2.56c.78,1.09,1.19,2.33,1.23,3.74h-3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m318.72,444.96c-.67,0-1.23-.22-1.71-.67-.47-.45-.71-.98-.71-1.6s.24-1.17.71-1.62c.47-.45,1.04-.67,1.71-.67s1.23.22,1.71.67c.47.45.71.99.71,1.62s-.24,1.16-.71,1.6c-.47.45-1.04.67-1.71.67Zm-1.93,22.67v-19.64h3.82v19.64h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m325.75,467.63v-19.64h3.67v3.2h.24c.41-1.08,1.08-1.93,2.01-2.54.93-.61,2.04-.91,3.34-.91s2.41.31,3.3.92,1.55,1.46,1.98,2.53h.2c.47-1.05,1.21-1.89,2.24-2.51,1.02-.63,2.24-.94,3.66-.94,1.78,0,3.24.56,4.37,1.67,1.13,1.12,1.69,2.8,1.69,5.05v13.17h-3.82v-12.81c0-1.33-.36-2.29-1.09-2.89-.72-.6-1.59-.89-2.6-.89-1.24,0-2.21.38-2.9,1.14s-1.04,1.74-1.04,2.93v12.52h-3.81v-13.05c0-1.07-.33-1.92-1-2.57-.66-.65-1.53-.97-2.59-.97-.72,0-1.39.19-2,.57-.61.38-1.1.91-1.47,1.58-.37.67-.56,1.45-.56,2.34v12.11h-3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m357.56,474.99v-27h3.73v3.18h.32c.22-.41.54-.88.96-1.42.42-.54,1-1.01,1.74-1.41.74-.4,1.72-.61,2.94-.61,1.59,0,3,.4,4.24,1.2,1.24.8,2.22,1.96,2.93,3.46.71,1.51,1.07,3.32,1.07,5.45s-.35,3.94-1.06,5.45c-.71,1.51-1.68,2.68-2.92,3.49-1.24.81-2.65,1.22-4.23,1.22-1.19,0-2.17-.2-2.92-.6-.75-.4-1.34-.87-1.77-1.41-.43-.54-.75-1.01-.98-1.43h-.23v10.42h-3.82Zm3.75-17.18c0,1.38.2,2.59.6,3.63s.98,1.85,1.74,2.44c.76.58,1.69.88,2.79.88s2.1-.3,2.86-.91c.77-.61,1.35-1.44,1.75-2.49.4-1.05.59-2.23.59-3.54s-.19-2.46-.58-3.49c-.39-1.03-.97-1.84-1.74-2.44s-1.73-.89-2.88-.89-2.04.29-2.81.86-1.34,1.37-1.73,2.39c-.39,1.02-.59,2.22-.59,3.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m383.6,441.45v26.18h-3.82v-26.18h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m397.2,468.02c-1.93,0-3.6-.42-4.99-1.25-1.39-.83-2.47-2-3.22-3.52-.75-1.51-1.13-3.29-1.13-5.32s.38-3.78,1.13-5.32c.75-1.53,1.81-2.73,3.17-3.59,1.36-.86,2.95-1.29,4.78-1.29,1.11,0,2.18.18,3.22.55,1.04.37,1.97.94,2.8,1.73.83.78,1.48,1.8,1.96,3.05.48,1.25.72,2.76.72,4.54v1.35h-15.61v-2.86h11.86c0-1.01-.21-1.9-.61-2.68-.41-.78-.98-1.4-1.72-1.85-.74-.45-1.6-.68-2.59-.68-1.07,0-2.01.26-2.81.79s-1.41,1.21-1.84,2.05c-.43.84-.65,1.75-.65,2.73v2.24c0,1.31.23,2.43.7,3.35.46.92,1.11,1.62,1.95,2.1.83.48,1.81.72,2.93.72.72,0,1.38-.1,1.98-.31s1.11-.52,1.55-.94c.43-.42.77-.93,1-1.55l3.62.65c-.29,1.07-.81,2-1.55,2.79-.75.8-1.68,1.42-2.8,1.85-1.12.44-2.4.66-3.83.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m427.04,468c-1.76,0-3.27-.32-4.53-.96-1.27-.64-2.24-1.51-2.92-2.61s-1.02-2.35-1.02-3.75c0-1.07.22-2.01.67-2.84.44-.83,1.06-1.6,1.85-2.31.79-.71,1.71-1.42,2.75-2.13l4.22-2.98c.72-.47,1.27-.97,1.67-1.49.4-.52.6-1.17.6-1.95,0-.61-.26-1.2-.79-1.76-.53-.56-1.24-.84-2.12-.84-.61,0-1.15.15-1.62.45-.46.3-.83.68-1.09,1.14-.26.46-.39.95-.39,1.46,0,.6.16,1.2.49,1.8.33.61.75,1.23,1.27,1.87s1.07,1.31,1.64,2l12.16,14.54h-4.32l-10.06-11.83c-.84-1-1.63-1.94-2.35-2.82-.72-.88-1.31-1.78-1.76-2.68-.45-.91-.67-1.89-.67-2.95,0-1.2.28-2.27.82-3.2.55-.93,1.32-1.66,2.31-2.19.99-.53,2.15-.79,3.48-.79s2.5.26,3.47.79,1.71,1.22,2.24,2.08.79,1.81.79,2.83c0,1.25-.31,2.34-.93,3.29s-1.47,1.82-2.55,2.61l-5.25,3.87c-1.02.75-1.73,1.49-2.13,2.22-.4.73-.6,1.3-.6,1.71,0,.75.19,1.44.58,2.08.39.64.93,1.15,1.64,1.53.7.38,1.53.58,2.47.58s1.92-.21,2.84-.63c.92-.42,1.76-1.03,2.52-1.82.75-.79,1.35-1.74,1.8-2.85s.66-2.35.66-3.72h3.45c0,1.69-.19,3.11-.58,4.28-.38,1.16-.85,2.11-1.39,2.84-.54.73-1.05,1.3-1.53,1.71-.15.14-.3.27-.44.41-.14.14-.28.27-.43.41-.89.89-1.96,1.56-3.21,1.98s-2.5.64-3.71.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m452.7,467.63v-26.18h16.42v3.4h-12.46v7.98h11.61v3.39h-11.61v8.02h12.62v3.4h-16.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m477.92,441.45v26.18h-3.82v-26.18h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m491.52,468.02c-1.94,0-3.6-.42-4.99-1.25-1.39-.83-2.47-2-3.22-3.52-.75-1.51-1.13-3.29-1.13-5.32s.38-3.78,1.13-5.32c.75-1.53,1.81-2.73,3.17-3.59,1.36-.86,2.95-1.29,4.77-1.29,1.11,0,2.18.18,3.22.55,1.04.37,1.97.94,2.8,1.73.83.78,1.48,1.8,1.96,3.05.48,1.25.71,2.76.71,4.54v1.35h-15.61v-2.86h11.86c0-1.01-.2-1.9-.61-2.68-.41-.78-.98-1.4-1.72-1.85-.74-.45-1.6-.68-2.59-.68-1.07,0-2.01.26-2.8.79-.8.52-1.41,1.21-1.84,2.05-.43.84-.65,1.75-.65,2.73v2.24c0,1.31.23,2.43.7,3.35.46.92,1.12,1.62,1.95,2.1s1.81.72,2.93.72c.72,0,1.39-.1,1.98-.31.6-.21,1.11-.52,1.55-.94.43-.42.77-.93,1-1.55l3.62.65c-.29,1.07-.81,2-1.55,2.79-.75.8-1.68,1.42-2.8,1.85-1.12.44-2.4.66-3.83.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m512.44,475.4c-1.56,0-2.9-.2-4.02-.61s-2.03-.95-2.74-1.62c-.71-.67-1.24-1.41-1.58-2.21l3.29-1.36c.23.38.54.77.93,1.2.39.42.92.78,1.58,1.08.67.3,1.53.45,2.59.45,1.45,0,2.65-.35,3.59-1.05.95-.7,1.42-1.82,1.42-3.36v-3.86h-.24c-.23.42-.56.88-.99,1.39-.43.51-1.02.96-1.77,1.33-.75.38-1.73.56-2.93.56-1.55,0-2.95-.36-4.19-1.09-1.24-.73-2.22-1.81-2.94-3.23s-1.08-3.19-1.08-5.27.36-3.88,1.07-5.37c.71-1.49,1.69-2.63,2.93-3.43s2.65-1.2,4.23-1.2c1.22,0,2.2.2,2.95.61.75.41,1.34.88,1.76,1.41s.75,1.01.98,1.42h.28v-3.18h3.75v20.07c0,1.69-.39,3.07-1.18,4.16-.78,1.08-1.84,1.88-3.18,2.4-1.33.52-2.84.78-4.51.78Zm-.04-11.24c1.1,0,2.03-.26,2.79-.77.76-.52,1.34-1.26,1.74-2.22.4-.97.59-2.13.59-3.48s-.2-2.48-.59-3.49c-.39-1-.97-1.79-1.73-2.36-.76-.57-1.7-.85-2.81-.85s-2.11.3-2.88.89c-.77.59-1.34,1.4-1.73,2.41-.39,1.01-.58,2.15-.58,3.4s.2,2.42.59,3.39c.39.97.97,1.73,1.75,2.28.77.54,1.72.82,2.86.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m532.14,468.06c-1.25,0-2.37-.23-3.38-.7-1.01-.46-1.8-1.14-2.38-2.03-.58-.89-.88-1.97-.88-3.26,0-1.11.21-2.02.64-2.74s1-1.28,1.73-1.7c.72-.42,1.53-.73,2.43-.95.89-.21,1.81-.38,2.74-.49,1.18-.14,2.13-.25,2.86-.34s1.27-.24,1.6-.44c.33-.2.5-.54.5-1v-.09c0-1.12-.31-1.98-.94-2.6s-1.56-.92-2.79-.92-2.3.28-3.04.85c-.74.57-1.25,1.2-1.53,1.89l-3.59-.82c.43-1.19,1.05-2.16,1.87-2.9s1.77-1.27,2.84-1.61c1.07-.34,2.2-.5,3.39-.5.78,0,1.62.09,2.5.27.88.18,1.71.52,2.48,1,.77.49,1.4,1.18,1.9,2.08s.74,2.06.74,3.5v13.04h-3.73v-2.68h-.15c-.25.49-.62.98-1.11,1.46-.49.48-1.13.87-1.91,1.19-.78.32-1.7.47-2.79.47Zm.83-3.07c1.06,0,1.96-.21,2.72-.63s1.33-.97,1.73-1.64c.4-.68.59-1.4.59-2.18v-2.53c-.14.14-.4.26-.79.38s-.83.21-1.32.29-.98.15-1.44.22c-.47.06-.86.12-1.18.16-.74.09-1.42.25-2.03.47-.61.22-1.1.54-1.46.95s-.54.96-.54,1.64c0,.95.35,1.66,1.05,2.14s1.59.72,2.67.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m550.74,455.97v11.66h-3.82v-19.64h3.67v3.2h.24c.45-1.04,1.16-1.88,2.13-2.51.97-.63,2.19-.95,3.66-.95,1.34,0,2.51.28,3.52.84s1.79,1.39,2.34,2.49c.55,1.1.83,2.46.83,4.08v12.49h-3.82v-12.03c0-1.42-.37-2.54-1.11-3.34-.74-.81-1.76-1.21-3.06-1.21-.89,0-1.67.19-2.36.58-.69.38-1.23.94-1.62,1.68-.4.74-.59,1.62-.59,2.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m577.59,447.99v3.07h-10.73v-3.07h10.73Zm-7.85-4.7h3.82v18.58c0,.74.11,1.3.33,1.67.22.37.51.62.86.75.35.13.74.2,1.16.2.31,0,.58-.02.81-.06.23-.04.41-.08.54-.1l.69,3.16c-.22.08-.54.17-.95.26-.41.09-.92.14-1.53.15-1.01.02-1.94-.16-2.81-.54s-1.57-.95-2.11-1.74-.81-1.77-.81-2.95v-19.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m595.16,441.45v26.18h-3.82v-26.18h3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m608.57,468.02c-1.84,0-3.45-.42-4.82-1.27-1.37-.84-2.44-2.02-3.2-3.54-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34,1.82-2.71,3.2-3.55c1.37-.84,2.98-1.27,4.82-1.27s3.45.42,4.82,1.27c1.37.84,2.44,2.03,3.2,3.55s1.14,3.31,1.14,5.34-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54-1.37.84-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.74-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46-.96-1.9-1.74-2.54c-.79-.64-1.77-.96-2.97-.96s-2.2.32-2.98.96c-.79.64-1.37,1.49-1.75,2.54s-.57,2.21-.57,3.46.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.98.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m630.25,468.02c-1.84,0-3.45-.42-4.82-1.27-1.37-.84-2.44-2.02-3.2-3.54-.76-1.52-1.14-3.29-1.14-5.32s.38-3.82,1.14-5.34c.76-1.53,1.82-2.71,3.2-3.55,1.37-.84,2.98-1.27,4.82-1.27s3.45.42,4.82,1.27c1.37.84,2.44,2.03,3.2,3.55.76,1.53,1.14,3.31,1.14,5.34s-.38,3.8-1.14,5.32c-.76,1.52-1.82,2.7-3.2,3.54-1.37.84-2.98,1.27-4.82,1.27Zm.01-3.21c1.19,0,2.18-.32,2.97-.95.78-.63,1.37-1.47,1.75-2.52.38-1.05.57-2.2.57-3.46s-.19-2.41-.57-3.46-.96-1.9-1.75-2.54c-.78-.64-1.77-.96-2.97-.96s-2.2.32-2.99.96c-.79.64-1.37,1.49-1.75,2.54-.38,1.05-.57,2.21-.57,3.46s.19,2.42.57,3.46c.38,1.05.96,1.89,1.75,2.52.79.63,1.78.95,2.99.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m643.67,467.63v-26.18h3.82v26.18h-3.82Zm3.52-6.66l-.03-4.67h.67l7.82-8.31h4.58l-8.92,9.46h-.6l-3.52,3.52Zm8.88,6.66l-7.03-9.33,2.63-2.67,9.09,12h-4.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m678.41,452.78l-3.46.61c-.14-.44-.37-.87-.68-1.27-.31-.4-.73-.73-1.26-.98-.53-.26-1.19-.38-1.98-.38-1.08,0-1.99.24-2.71.72s-1.09,1.1-1.09,1.86c0,.66.24,1.19.73,1.59.49.4,1.27.73,2.35.98l3.12.72c1.81.42,3.15,1.06,4.04,1.93.89.87,1.33,2,1.33,3.39,0,1.18-.34,2.22-1.02,3.14-.68.92-1.62,1.63-2.83,2.15-1.21.52-2.6.78-4.19.78-2.2,0-3.99-.47-5.38-1.41-1.39-.94-2.24-2.28-2.56-4.02l3.7-.56c.23.96.7,1.69,1.42,2.18.72.49,1.65.74,2.8.74,1.25,0,2.25-.26,3-.79s1.12-1.17,1.12-1.92c0-.61-.23-1.13-.68-1.55-.46-.42-1.15-.73-2.09-.95l-3.32-.73c-1.83-.42-3.19-1.08-4.06-1.99-.87-.91-1.31-2.07-1.31-3.46,0-1.16.32-2.17.97-3.04s1.54-1.55,2.68-2.04c1.14-.49,2.45-.73,3.92-.73,2.12,0,3.79.46,5.01,1.37s2.02,2.14,2.42,3.67Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 435.74,
    y: 298.53,
    width: 100,
    height: 100
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 476.84,
    y: 371.05,
    width: 18.44,
    height: 6.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m495.34,331.84l-7.88-12.47h-.21c-.38,0-.69.31-.69.69v20.76c0,.63.39,1.18.96,1.43,1.54.68,2.62,2.22,2.63,4.02,0,2.32-1.85,4.29-4.16,4.41-2.54.14-4.65-1.89-4.65-4.4,0-1.8,1.08-3.35,2.63-4.03.58-.25.96-.81.96-1.44v-20.75c0-.38-.31-.69-.69-.69h-.21l-7.88,12.47-6.99,10.77c-1.36,2.1-1.61,4.73-.66,7.04l8.24,20.11h18.01l8.24-20.11c.95-2.31.7-4.94-.66-7.04l-6.99-10.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m496.06,371.77h-20.05c-.25,0-.46-.2-.46-.46h0c0-.25.2-.46.46-.46h20.05c.25,0,.46.2.46.46h0c0,.25-.2.46-.46.46Z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1222,
    y: 694,
    width: 300,
    height: 75,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 1222,
    y: 679,
    width: 300,
    height: 75,
    rx: 15,
    ry: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m1732,559.36h-720V182.16c0-7.07,5.73-12.8,12.8-12.8h694.4c7.07,0,12.8,5.73,12.8,12.8v377.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1702,169.36c5.47,0,10.58,1.49,15,4.05v70.95h-15v-75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1687,
    y: 169.36,
    width: 7.5,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m1042,169.36c-5.47,0-10.58,1.49-15,4.05v70.95h15v-75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1732,559h-720V181.8c0-7.07,5.73-12.8,12.8-12.8h694.4c7.07,0,12.8,5.73,12.8,12.8v377.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m1719.2,619h-694.4c-7.07,0-12.8-5.73-12.8-12.8v-47.2h720v47.2c0,7.07-5.73,12.8-12.8,12.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 1042,
    y: 199,
    width: 660,
    height: 330
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1079.5,
    y: 236.5,
    width: 300,
    height: 195
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1477,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1252,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1289.5,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1327,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1364.5,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1402,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1439.5,
    y: 491.5,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1559.5,
    y: 236.5,
    width: 90,
    height: 240
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1282,
    y: 619,
    width: 180,
    height: 105
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1282,
    y: 619,
    width: 180,
    height: 30
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "1462 724 1462 679 1507 679 1462 724"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-28",
    cx: 1372,
    cy: 589,
    r: 7.5,
    transform: "translate(97.88 1367.41) rotate(-54.66)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "1672 289 1702 319 1702 259 1672 229 1672 289"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1672,
    y: 229,
    width: 90,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1469.5,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1244.5,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1282,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1319.5,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1357,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1394.5,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1432,
    y: 484,
    width: 30,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1072,
    y: 229,
    width: 300,
    height: 195
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1072,
    y: 229,
    width: 300,
    height: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 1364.5,
    cy: 236.5,
    r: 5.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 1349.5,
    cy: 236.5,
    r: 5.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 1334.5,
    cy: 236.5,
    r: 5.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 1087,
    y: 259,
    width: 82.5,
    height: 82.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1087,
    y: 349,
    width: 22.5,
    height: 22.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1117,
    y: 349,
    width: 22.5,
    height: 22.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1147,
    y: 349,
    width: 22.5,
    height: 22.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1177,
    y: 349,
    width: 22.5,
    height: 22.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1207,
    y: 349,
    width: 22.5,
    height: 22.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1237,
    y: 349,
    width: 22.5,
    height: 22.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1177,
    y: 259,
    width: 82.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1177,
    y: 274,
    width: 82.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1177,
    y: 289,
    width: 82.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1177,
    y: 304,
    width: 82.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1177,
    y: 319,
    width: 82.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 1207,
    y: 334,
    width: 52.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 1177,
    y: 334,
    width: 22.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1552,
    y: 229,
    width: 90,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1552,
    y: 289,
    width: 90,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1552,
    y: 349,
    width: 90,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 1552,
    y: 409,
    width: 90,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1582,
    y: 229,
    width: 60,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1582,
    y: 289,
    width: 60,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1582,
    y: 349,
    width: 60,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1582,
    y: 409,
    width: 60,
    height: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1552,
    y1: 289,
    x2: 1642,
    y2: 289
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1552,
    y1: 349,
    x2: 1642,
    y2: 349
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 1552,
    y1: 409,
    x2: 1642,
    y2: 409
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1619.5,
    y: 251.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 1604.5,
    y: 251.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 1589.5,
    y: 251.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1574.5,
    y: 251.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1559.5,
    y: 251.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 1559.5,
    y: 311.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 1559.5,
    y: 266.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 1567,
    y: 319,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1574.5,
    y: 266.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 1589.5,
    y: 266.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 1604.5,
    y: 266.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 1619.5,
    y: 266.5,
    width: 15,
    height: 15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1589.5,
    y: 311.5,
    width: 45,
    height: 3.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 1589.5,
    y: 320.88,
    width: 45,
    height: 3.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 1589.5,
    y: 330.25,
    width: 45,
    height: 3.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1559.5,
    y: 371.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1559.5,
    y: 431.5,
    width: 75,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1559.5,
    y: 446.5,
    width: 75,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1559.5,
    y: 386.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1576.38,
    y: 386.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1576.38,
    y: 371.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1593.25,
    y: 371.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1593.25,
    y: 386.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1610.12,
    y: 386.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1610.12,
    y: 371.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1627,
    y: 371.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 1627,
    y: 386.5,
    width: 7.5,
    height: 7.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1687,
    y: 244,
    width: 60,
    height: 7.5
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset2);
export default __webpack_public_path__ + "static/media/Asset 2.bf5dcd33dfb49ffc909fa0f013c14661.svg";
export { ForwardRef as ReactComponent };